/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Injectable } from '@angular/core';
import { Table } from 'primeng/table';

@Injectable({
  providedIn: 'root',
})
export class TableOverridesService {
  public overridesForMultipleSelectionMode(): void {
    // https://github.com/primefaces/primeng/blob/master/src/app/components/table/table.ts
    Table.prototype.dataToRender = function(data: any) {
      const _data = data || this.processedData;

      if (_data && this.paginator && !this.lazy) {
        const first =  this.first;

        return _data.slice(first, (first as number) + (this.rows as number));
      }

      return _data;
    };
  }
}
